import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

type PosRuntimeConfig = {
  apiBaseUrl?: string;
  apiTimeout?: number;
  terminalId?: string;
  storeId?: string;
  posKioskMode?: boolean;
  enableOfflineMode?: boolean;
  paymentTerminalMode?: 'mock' | 'http-simulator';
  simTerminalBaseUrl?: string;
  simTerminalHealthPath?: string;
  simTerminalProcessPath?: string;
  simTerminalCancelPath?: string;
  simTerminalTimeoutMs?: number;
  printMode?: 'backend' | 'local' | 'hybrid';
  printServerMode?: 'api-base' | 'http-simulator';
  printServerBaseUrl?: string;
  printServerHealthPath?: string;
  printServerGeneratePrefix?: string;
  printServerByOrderPrefix?: string;
  printServerTimeoutMs?: number;
};

declare global {
  interface Window {
    __CONAI_POS_RUNTIME__?: PosRuntimeConfig;
  }
}

async function loadRuntimeConfig(): Promise<void> {
  try {
    const response = await fetch('./runtime.json', { cache: 'no-store' });
    if (!response.ok) {
      return;
    }

    const payload = (await response.json()) as unknown;
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return;
    }

    window.__CONAI_POS_RUNTIME__ = payload as PosRuntimeConfig;
  } catch {
    // Ignore runtime config load errors and fallback to VITE env values.
  }
}

async function bootstrap(): Promise<void> {
  await loadRuntimeConfig();
  const { App } = await import('./App');

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void bootstrap();
